import React from 'react';
import { createRoot } from 'react-dom/client';
import OrderModal from './orderModal/orderModal';

const languagePrefix = document.getElementById('order-modal-entry').attributes['data-language-prefix']?.value;

const root = createRoot(document.getElementById('order-modal-entry'));
const props = JSON.parse(JSON.stringify(window.__PRELOADED_ORDER_MODAL_STATE__));
root.render(<OrderModal languagePrefix={languagePrefix} {...props} />);
